var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./notification-panel.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6c252b54\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./notification-panel.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/notification/notification-panel/notification-panel.vue.html
// module id = rDg6
// module chunks = 2